module.exports = __webpack_public_path__ + "media/53.88329c66.wav";